import { LOCALE_ID, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CourseDetailComponent } from './course-detail/course-detail.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { SharedModule } from './sharedModule/shared/shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DatePipe } from '@angular/common';
import { RecaptchaModule } from 'ng-recaptcha';
import { registerLocaleData } from '@angular/common';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { IonicSelectableModule } from 'ionic-selectable';

import localeFr from '@angular/common/locales/fr';
import { OrderModule } from 'ngx-order-pipe';
import { FooterComponent } from './footer/footer.component';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgStreamingModule } from '@videogular/ngx-videogular/streaming';


// the second parameter 'fr' is optional
registerLocaleData(localeFr, 'fr');

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
const cookieConfig:NgcCookieConsentConfig = {
  cookie: {
    // Empty domain → the consent cookie is set on the current host in every
    // environment (localhost, staging, prod). A hardcoded domain stopped the
    // cookie from being set off that exact domain, so the banner reappeared on
    // every load and overlapped the footer links, making them unclickable.
    domain: ''
  },
  position: 'bottom-right',
  palette: {
    popup: {
      background: '#ffffff',
      text: '#0a0a0a'
    },
    button: {
      background: '#0033a0',
      text: '#ffffff'
    }
  },
  theme: 'edgeless',
  type: 'opt-out'
};

@NgModule({
  declarations: [AppComponent, CourseDetailComponent],

  imports: [NgcCookieConsentModule.forRoot(cookieConfig),
    BrowserModule,
    IonicModule.forRoot({
      mode: 'md'
    }),
    SharedModule,
    AppRoutingModule,
    RecaptchaModule,
    OrderModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    HttpClientModule,
    IonicSelectableModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }), // add HttpClientModule to active translate,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgStreamingModule,

  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {provide: LOCALE_ID, useValue: 'fr' },
        DatePipe
],
  bootstrap: [AppComponent]
})

export class AppModule {
}
